// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alerts-banner {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.1), rgba(239, 68, 68, 0.05));
  border: 1px solid var(--alert-color);
  border-radius: var(--radius-lg);
  margin-bottom: var(--spacing-lg);
  overflow: hidden;
  animation: alertPulse 2s ease-in-out infinite;
}

@keyframes alertPulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.2); }
  50% { box-shadow: 0 0 20px 0 rgba(239, 68, 68, 0.3); }
}

.alert-header {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-md) var(--spacing-lg);
  cursor: pointer;
  transition: background var(--transition-fast);
}

.alert-header:hover {
  background: rgba(239, 68, 68, 0.1);
}

.alert-icon {
  position: relative;
}

.warning-icon {
  font-size: 1.75rem;
}

.alert-count {
  position: absolute;
  top: -4px;
  right: -8px;
  background: var(--alert-color);
  color: white;
  font-size: 0.7rem;
  font-weight: 600;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert-summary {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.alert-title {
  font-weight: 600;
  color: var(--text-primary);
}

.alert-headline {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.alert-actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.severity-badge {
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.severity-badge.extreme {
  background: var(--alert-extreme);
  color: white;
}

.severity-badge.severe {
  background: var(--alert-severe);
  color: white;
}

.severity-badge.moderate {
  background: var(--alert-moderate);
  color: black;
}

.severity-badge.minor {
  background: var(--alert-minor);
  color: white;
}

.expand-btn {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: var(--spacing-xs);
}

.alerts-list {
  border-top: 1px solid var(--border-color);
  padding: var(--spacing-md) var(--spacing-lg);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.alert-item {
  background: var(--bg-card);
  border-radius: var(--radius-md);
  padding: var(--spacing-md);
}

.alert-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-sm);
}

.alert-event {
  font-weight: 600;
  color: var(--text-primary);
}

.alert-description {
  font-size: 0.9rem;
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: var(--spacing-sm);
}

.alert-instruction {
  font-size: 0.85rem;
  color: var(--text-primary);
  line-height: 1.5;
  margin-bottom: var(--spacing-sm);
  padding: var(--spacing-sm);
  background: rgba(255, 255, 255, 0.05);
  border-left: 3px solid var(--alert-color, var(--text-muted));
  border-radius: var(--radius-sm);
}

.dismiss-btn {
  background: transparent;
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-size: 0.8rem;
}

.dismiss-btn:hover {
  background: var(--bg-card-hover);
}
`, "",{"version":3,"sources":["webpack://./src/components/AlertsBanner/AlertsBanner.css"],"names":[],"mappings":"AAAA;EACE,oFAAoF;EACpF,oCAAoC;EACpC,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,WAAW,0CAA0C,EAAE;EACvD,MAAM,6CAA6C,EAAE;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAC1B,qCAAqC;EACrC,4DAA4D;EAC5D,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;EAC5B,4CAA4C;EAC5C,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".alerts-banner {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.1), rgba(239, 68, 68, 0.05));\n  border: 1px solid var(--alert-color);\n  border-radius: var(--radius-lg);\n  margin-bottom: var(--spacing-lg);\n  overflow: hidden;\n  animation: alertPulse 2s ease-in-out infinite;\n}\n\n@keyframes alertPulse {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.2); }\n  50% { box-shadow: 0 0 20px 0 rgba(239, 68, 68, 0.3); }\n}\n\n.alert-header {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  padding: var(--spacing-md) var(--spacing-lg);\n  cursor: pointer;\n  transition: background var(--transition-fast);\n}\n\n.alert-header:hover {\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.alert-icon {\n  position: relative;\n}\n\n.warning-icon {\n  font-size: 1.75rem;\n}\n\n.alert-count {\n  position: absolute;\n  top: -4px;\n  right: -8px;\n  background: var(--alert-color);\n  color: white;\n  font-size: 0.7rem;\n  font-weight: 600;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.alert-summary {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.alert-title {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.alert-headline {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.alert-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n}\n\n.severity-badge {\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.severity-badge.extreme {\n  background: var(--alert-extreme);\n  color: white;\n}\n\n.severity-badge.severe {\n  background: var(--alert-severe);\n  color: white;\n}\n\n.severity-badge.moderate {\n  background: var(--alert-moderate);\n  color: black;\n}\n\n.severity-badge.minor {\n  background: var(--alert-minor);\n  color: white;\n}\n\n.expand-btn {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: var(--spacing-xs);\n}\n\n.alerts-list {\n  border-top: 1px solid var(--border-color);\n  padding: var(--spacing-md) var(--spacing-lg);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n}\n\n.alert-item {\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-md);\n}\n\n.alert-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--spacing-sm);\n}\n\n.alert-event {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.alert-description {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin-bottom: var(--spacing-sm);\n}\n\n.alert-instruction {\n  font-size: 0.85rem;\n  color: var(--text-primary);\n  line-height: 1.5;\n  margin-bottom: var(--spacing-sm);\n  padding: var(--spacing-sm);\n  background: rgba(255, 255, 255, 0.05);\n  border-left: 3px solid var(--alert-color, var(--text-muted));\n  border-radius: var(--radius-sm);\n}\n\n.dismiss-btn {\n  background: transparent;\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.dismiss-btn:hover {\n  background: var(--bg-card-hover);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
